import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';

const BackgroundSection = () => {
  const obfuscateUrl = (url) => btoa(url); // Base64 encode the URL
  const deObfuscateUrl = (encodedUrl) => atob(encodedUrl); // Base64 decode
  const [currentTime, setCurrentTime] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [shuffledAudioUrls, setShuffledAudioUrls] = useState([]);
  const [shuffledVideoUrls, setShuffledVideoUrls] = useState([]);
  const videoTimeoutRef = useRef(null);

    const audioUrls = [
        "https://cdn.gclite.org/audios/15.mp3",
        "https://cdn.gclite.org/audios/1.mp3",
        "https://cdn.gclite.org/audios/3.mp3",
        "https://cdn.gclite.org/audios/4.mp3",
        "https://cdn.gclite.org/audios/5.mp3",
        "https://cdn.gclite.org/audios/9.mp3",
        "https://cdn.gclite.org/audios/6.mp3",
        "https://cdn.gclite.org/audios/8.mp3",
        "https://cdn.gclite.org/audios/9.mp3",
        "https://cdn.gclite.org/audios/7.mp3",
        "https://cdn.gclite.org/audios/10.mp3",
        "https://cdn.gclite.org/audios/11.mp3",
        "https://cdn.gclite.org/audios/12.mp3",
        "https://cdn.gclite.org/audios/14.mp3",
        "https://cdn.gclite.org/audios/13.mp3",
    ];

    const videoUrls = [
        "https://cdn.gclite.org/videos/init.mp4",
        "https://cdn-media.f-static.net/uploads/9427363/normal_668a7baa0e74f.mp4",
        "https://static.s123-cdn-static-d.com/uploads/8636362/normal_66144b6f64ba3.mp4",
        "https://cdn.gclite.org/videos/*.mp4",
    ];


    // Shuffle an array
    const shuffleArray = (array) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    // Cache media files using Cache API
    const cacheMediaFiles = async (urls) => {
        if ('caches' in window) {
            const cache = await caches.open('media-cache');
            await Promise.all(
                urls.map(async (url) => {
                    const cachedResponse = await cache.match(url);
                    if (!cachedResponse) {
                        await cache.add(url);
                    }
                })
            );
        }
    };

    useEffect(() => {
        // Update time and date every second
        const intervalId = setInterval(() => {
            const now = new Date();
            setCurrentTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
            setCurrentDate(now.toLocaleDateString([], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
        }, 1000);

        // Shuffle and cache media URLs
        setShuffledAudioUrls(shuffleArray(audioUrls.map(obfuscateUrl)));
        setShuffledVideoUrls(shuffleArray(videoUrls.map(obfuscateUrl)));
        cacheMediaFiles([...audioUrls, ...videoUrls]);

        return () => clearInterval(intervalId); // Cleanup
    }, []);

    useEffect(() => {
        // Set timeout for video playback
        if (shuffledVideoUrls.length > 0) {
            videoTimeoutRef.current = setTimeout(() => {
                if (currentVideoIndex < shuffledVideoUrls.length - 1) {
                    setCurrentVideoIndex(currentVideoIndex + 1);
                } else {
                    setCurrentVideoIndex(0);
                }
            }, 35000);
        }
        return () => clearTimeout(videoTimeoutRef.current); // Cleanup timeout
    }, [currentVideoIndex, shuffledVideoUrls]);

    const handleAudioEnded = () => {
        setCurrentAudioIndex((prevIndex) =>
            prevIndex < shuffledAudioUrls.length - 1 ? prevIndex + 1 : 0
        );
    };

    const handleVideoEnded = () => {
        clearTimeout(videoTimeoutRef.current); // Clear timeout if video ends naturally
        setCurrentVideoIndex((prevIndex) =>
            prevIndex < shuffledVideoUrls.length - 1 ? prevIndex + 1 : 0
        );
    };

	const lazyLoadCSS = (href) => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = href;
		document.head.appendChild(link);
	};

	const loadScriptAtEnd = (url) => {
		const script = document.createElement('script');
		script.src = url;
		script.async = true;
		script.onerror = () => console.error(`Failed to load ${url}`);
		document.body.appendChild(script); // Append script to the body
	};

	const initializeLazyLoading = () => {
		const cssFiles = [
			'./components/NeonButtons.css',
			'https://cdn.gclite.org/login/css/synolog.css',
			'https://cdn.gclite.org/login/css/synolog.min.css',
			'https://cdn.gclite.org/login/css/SYNO.styles.css',
			'https://cdn-cms-s.f-static.net/files/font-awesome-4.7/css/font-awesome.min.css',
			'https://cdn-cms-s.f-static.net/versions/2/css/minimize_main.css',
			'https://cdn-cms-s.f-static.net/versions/2/css/websiteCSS.css?w=&orderScreen=&websiteID=8636362&onlyContent=&tranW=&v=css_y226_54064689',
		];
		const jsFiles = [
			"https://cdn.gclite.org/login/js/misc.js",
			"https://cdn.gclite.org/login/js/prototype.js",
			"https://cdn-cms-s.f-static.net/versions/2/js/minimize_p1.js",
			"https://cdn-cms-s.f-static.net/versions/2/js/minimize_p2.js",
			"https://cdn-cms-s.f-static.net/versions/2/js/minimize_p3.js",
			"https://cdn-cms-s.f-static.net/versions/2/js/minimize_p4.js",
			"https://cdn-cms-s.f-static.net/versions/2/js/js.php?umk=1-169",
			"https://cdn-cms-s.f-static.net/versions/2/js/minimize_scripts.js",
			"https://cdn.gclite.org/js/media.js",
		];

		// Load CSS files
		cssFiles.forEach(lazyLoadCSS);

		// Load JS files at the bottom of the page
		jsFiles.forEach(loadScriptAtEnd);
	};
    useEffect(() => {
        initializeLazyLoading();
    }, []);
	
  return (
	<div>
      <body id="page-top" data-aos-easing="ease" data-aos-duration="200" data-aos-delay="0">
        <div className="body">
			<div id="sds-login" className="sds-login-dark">
				<div className="sds-login-logo">
				  <div className="ed-element ed-logo logo" id="ed-472659994">
					<div className="sds-login-logo">
					  <span>
						  <a href="/">
							<img
							  alt="sds-logo"
							  width="56"
							  src="https://dreamx-14fe8.web.app/images/logo.webp"
							  style={{ float: 'left', margin: '2px 20px 10px 0px' }}
							/>
						  </a>
					  </span>
					</div>
				  </div>
				</div>
				<br/>
				<br/>

				<div className="sds-login-welcome-info">
					<div id="sds-weather-info">
						<div id="ext-comp-1007" name="ext-comp-1007" className=" x-form-display-field current-time">
							<span className="time-tag">{currentTime}</span>
						</div>
						<div id="ext-comp-1008" name="ext-comp-1008" className=" x-form-display-field current-date">{currentDate}</div>
					</div>
				</div>
            </div>
          <div id="s123ModulesContainer" className="s123-modules-container">
            <section
              id="section-169"
              className="s123-module s123-module-headers layout-26 bg-half-opacity headers-fix-mobile-height"
              data-parallax-images-amount="3"
              data-module-id="169"
              data-module-type-num="169"
              data-slider-speed="35"
              data-menu-opacity="true"
              data-box-color="bg-primary-black"
              data-version="2"
            >
              <div className="container-fluid">
                <div className="headers-container hpm-height-100vh">
					{shuffledAudioUrls.length > 0 && (
					  <audio
						loop={false}
						src={deObfuscateUrl(shuffledAudioUrls[currentAudioIndex])}
						autoPlay
						onEnded={handleAudioEnded}
					  ></audio>
					)}
                  <div className="headers-img-wrap" style={{ "--layout26OpacityColor": "0, 0, 0" }}>
                    <div data-ride="carousel" className="carousel slide carousel-fade">
                      <div className="carousel-inner">
                        <div className="item active">
                          <div className="headers-item">
                            <div className="video-bg">
							  {shuffledVideoUrls.length > 0 && (
								<video
								  className="headers-bg-video"
								  loop={false}
								  autoPlay
								  muted
								  controlsList="nodownload"
								  preload="auto"
								  src={deObfuscateUrl(shuffledVideoUrls[currentVideoIndex])}
								  onEnded={handleVideoEnded}
								></video>
							  )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div></div>
        </div>
      </body>
    </div>
  );
};

export default BackgroundSection;